// src/themes/vibrante.js
//
// Tema Vibrante — evolución moderna del producto.
// Cyan HUD moderado sobre navy luminoso, pensado para operadores que
// prefieren mayor contraste e identidad visual.
//
// El accent se bajó de #00D4FF (C 0.15, borderline alto) a #49C4E8
// (C 0.13, dentro de zona de confort). Mantiene carácter HUD cyan sin
// quemar la retina en turnos largos.

export default {
  id: 'vibrante',
  label: 'Vibrante (HUD)',
  mapBasemap: 'dark',

  // ========== SISTEMA A — CHROME ==========

  // Identidad — cyan moderado, L 76 C 0.13 H 220
  accent:       '#49C4E8',
  accentSoft:   'rgba(73, 196, 232, 0.22)',
  accentGlow:   'rgba(73, 196, 232, 0.40)',
  accentBright: '#7BDAF5',

  // Fondos — navy luminoso, 3 niveles
  bgDeep:    '#0A2036',
  bgSurface: '#122A45',
  bgCard:    '#040E1A',
  bgOverlay: 'rgba(10, 32, 54, 0.92)',

  // Texto — off-white con tinte azul sutil
  text:      '#E6EDF5',
  textMuted: '#8C9BB3',
  textDim:   '#64708B',

  // Bordes
  borderDim:    'rgba(255, 255, 255, 0.08)',
  borderNormal: 'rgba(255, 255, 255, 0.12)',
  borderAccent: 'rgba(73, 196, 232, 0.35)',

  // Trail GPS
  trailLine: '#00BCD4',

  // Murphy themed — derivado del cyan accent. Solo se aplica si el modo
  // Murphy es 'themed'. En 'neutral' (default) lo overridean los grises.
  murphyLight: '#7BDAF5',
  murphyMid:   '#49C4E8',
  murphyDeep2: '#2A8AAB',
  murphyDeep1: '#1B5C72',
  murphyInk:   '#0A1B22',

  // Tokens extendidos — Vibrante usa defaults neutros
  fontFamily:         "'Public Sans', -apple-system, BlinkMacSystemFont, sans-serif",
  labelTransform:     'none',
  labelLetterSpacing: 'normal',
  accentTextShadow:   'none',
  alertTextShadow:    'none',
  accentBoxShadow:    'none',
  alertBoxShadow:     'none',
  routeActiveWidth:   4,
  routePreviewWidth:  2.5,
  clusterMode:        'colorful',

  // ========== Categorías 911 (manual oficial federal CNIE v3.0) ==========
  // Versión vibrante: tonos profundos y saturados, alto contraste sobre
  // bg oscuro. Familia cromática del manual federal mantenida.
  catSeguridad:         '#2B5FA8',  // azul profundo
  catMedico:            '#2E8540',  // verde profundo
  catProteccionCivil:   '#C49A1F',  // amarillo dorado profundo (separado de asistencia)
  catServiciosPublicos: '#5E3FA6',  // morado profundo
  catAsistencia:        '#A85725',  // naranja-rojizo profundo (separado de PC)
  catOtrosServicios:    '#4A5562',  // gris oscuro
  catMalUso:            '#A32D2D',  // rojo profundo
}
